<template>
  <div class="home">
    <div class="container">
      <div class="row justify-content-end">
        <!-- <a href="/al">ｺﾝﾃﾅ配車日検索</a>&nbsp;<a href="/ak">ｵｰﾀﾞｰ配車日検索</a>&nbsp;<a href="/ol">ｵｰﾀﾞｰ検索（ｺﾝﾃﾅ）</a> -->
        ｜<a href="/ak">配車日検索（ﾄﾗｯｸ）</a>｜&nbsp;&nbsp;&nbsp;<a href="/ol">コンテナ検索へ</a>
      </div>
    </div>
    <br />
    <div class="container">
      <div class="row justify-content-center">
        <div v-show="isLoading || isPwLoading" class="text-center">
          データ読み込み中です。
          <img src="../assets/loader.gif" />
        </div>
        <div v-show="!isLoading && !isAuthed">
          <form @submit.prevent="auth()">
            <div class="form-row form-inline">
              <div class="form-group">
                <div class="input-group">
                  <label for="password">パスワード：</label>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    size="16"
                    placeholder=""
                    v-bind:readonly="readonly"
                    :value="authNum"
                    @input="inputPassword($event.target.value)"
                  />
                  <div class="input-group-append pointer">
                    <div class="input-group-text">
                      <i class="fas fa-search" @click="auth()"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div v-show="!isLoading && isAuthed">
          <form @submit.prevent="search()">
            <div class="form-row form-inline">
              <div class="form-group">
                <div class="input-group">
                  <label for="orderNo" class="truck-color">オーダーNo：</label>
                  <input
                    type="text"
                    class="form-control"
                    id="orderNo"
                    size="8"
                    placeholder=""
                    v-bind:readonly="readonly"
                    :value="orderNo"
                    @input="inputOrderNo($event.target.value)"
                  />
                  <div class="input-group-append pointer" id="OrderNo2">
                    <div class="input-group-text" @click="search()">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="isAuthed && orderNo == ''">オーダーNoを入力してください。<br /></div>
      <div v-else-if="message != ''" v-html="message"></div>
      <div v-else>
        <div v-if="isInput && (truckDataSet == null || truckDataSet.length == 0) && isSearch">
          該当のデータはありません。<br />
        </div>
        <div v-else-if="truckDataSet != null && truckDataSet.length > 0">
          <br />
          <b>{{ orderNo }}の検索結果</b>
          <br />
          <table
            class="table table-striped table-hover table-bordered table-responsive-md table-sm row-scrollable"
            id="table"
          >
            <thead>
              <tr>
                <th class="align-middle text-center pointer" scope="col" @click="sortList('truck', String)">オーダーNo&nbsp;&nbsp;{{dispSortMark('truck')}}</th>
                <th class="align-middle text-center pointer" scope="col" @click="sortList('driver', String)">ドライバー情報&nbsp;&nbsp;{{dispSortMark('driver')}}</th>
                <th class="align-middle text-center pointer" scope="col" @click="sortList('history', String)">履歴&nbsp;&nbsp;{{dispSortMark('history')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, idx) in truckDataSet" :key="idx" @click="toEdit(data)">
                <td>
                  {{ dispTruckInfo(data) }}
                </td>
                <td>
                  {{ dispDriverInfo(data) }}
                </td>
                <td>
                  {{ dispHistory(data) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HttpClient from "../modules/http";

export default {
  name: "AdminList",
  components: {},
  data: function () {
    return {
      isLoading: false,
      isPwLoading: true,
      isInput: false,
      isAuthed: false,
      isSearch: false,
      authNum: "",
      passwd: "",
      executeSerach: false,
      truckDataSet: null,
      truckData: {
        truck: "",
        dispatchDate: "",
        pickupDate: "",
        departureDate: "",
        arrivalDate: "",
        complationDate: "",
        memo: "",
      },
      orderNo: "",
      message:"",
      httpClient: new HttpClient(),
      orderData: {
        isOrder: true,
        orderColumn: "order",
        isAsc: true,
        orderFunction: String,
      },
    };
  },
  created: function () {
    this.authNum = this.$cookie.getCookie("authNum");
    this.getPasswdData();
  },
  mounted:function() {
  },
  methods: {
    loadingOff(){
      this.isLoading = false;
      this.isPwLoading = false;
    },
    auth() {
      if (this.authNum == this.passwd) {
        this.isAuthed = true;
        this.$cookie.setCookie("authNum", this.passwd);
      } else {
        this.isAuthed = false;
      }
    },
    search() {
      if(this.orderNo != ""){
        this.message = ""
        this.getTruckData();
      }else{
        this.message = "オーダーNoを入力してください。"
      }
    },
    inputOrderNo(value){
      this.isInput = true
      this.orderNo = value
    },
    inputPassword(passwd){
      this.authNum = passwd
      this.auth()
    },
    sortList(name, func, asc) {
      if (asc == undefined || asc == null) {
        this.orderData.isAsc = !this.orderData.isAsc;
      } else {
        this.orderData.isAsc = asc;
      }

      this.orderData.orderColumn = name;
      this.orderData.isOrder = true;
      this.orderData.orderFunction = func;
      this.truckDataSet = this.truckDataSet.sort((a, b) => {
        if(name == "driver"){
          a = this.dispDriverInfo(a) + this.dispHistory(a);
          b = this.dispDriverInfo(b) + this.dispHistory(b);
        }else if(name == "truck"){
          a = this.dispTruckInfo(a);
          b = this.dispTruckInfo(b);
        }else{
          a = this.dispHistory(a);
          b = this.dispHistory(b);
        }
        return (
          (func(a) === func(b) ? 0 : func(a) > func(b) ? 1 : -1) *
          (this.orderData.isAsc ? 1 : -1)
        );
      });
    },
    dispDriverInfo(data) {
      if (data.memo != "") {
        const driverInfo = data.memo.split("@@");
        if (driverInfo.length >= 5) {
          return driverInfo[0] + " " + driverInfo[2];
        }
      }
      return "";
    },
    dispTruckInfo(data) {
      if (data.truck != "") {
        return data.truck;
      }
      return "";
    },
    dispHistory(data) {
      let time = ""
      if (data.pickupDate != "") {
        time = data.pickupDate + " PickUp"
        // let departureDate = data.departureDate.split(" ")
        // if(departureDate.length > 1){
        //   time = departureDate[1] + " 出発"
        // }else{
        //   time = departureDate[0] + " 出発"
        // }
      }

    if (data.departureDate != "") {
        time = data.departureDate + " 出発"
        // let departureDate = data.departureDate.split(" ")
        // if(departureDate.length > 1){
        //   time = departureDate[1] + " 出発"
        // }else{
        //   time = departureDate[0] + " 出発"
        // }
      }

      if (data.arrivalDate != "") {
        time = data.arrivalDate + " 到着"
        // let arrivalDate = data.arrivalDate.split(" ")
        // if(arrivalDate.length > 1){
        //   time = arrivalDate[1] + " 到着"
        // }else{
        //   time = arrivalDate[0] + " 到着"
        // }
      }

      if (data.complationDate != "") {
        time = data.complationDate + " 完了"
        // let complationDate = data.complationDate.split(" ")
        // if(complationDate.length > 1){
        //   time = complationDate[1] + " 完了"
        // }else{
        //   time = complationDate[0] + " 完了"
        // }
      }

      return time
    },
    dispSortMark(name){
      let ret = ""
      if(this.orderData.orderColumn == name){
        if(this.orderData.isAsc){
          ret = "▲"
        }else{
          ret = "▼"
        }
      }
      return ret;
    },
    getTruckData() {
      this.isLoading = true;
      const url = "file.d2dship.com/truckTrace/orderList/?no=" + this.orderNo;
      this.httpClient.get(url, this.onSuccess, this.onError);
    },
    getPasswdData() {
      this.isPwLoading = true;
      const url = "https://app.qrqr.work/energy/read.php";
      this.httpClient.getText(url, this.onSuccessPwd, this.onErrorPwd);
    },
    onSuccess(response) {
      this.isSearch = true;
      this.loadingOff();
      this.truckDataSet = JSON.stringify(response.data);
      this.truckDataSet = JSON.parse(this.truckDataSet);

      this.sortList('history', String,false);

      this.$forceUpdate();
    },
    onError(response) {
      this.isSearch = true;
      this.loadingOff();
      console.log(response)
    },
    onSuccessPwd(response) {
      this.loadingOff();
      let pwddata = JSON.stringify(response.data);
      pwddata = JSON.parse(pwddata);
      this.passwd = pwddata.energy;

      if (this.authNum != "") {
        this.auth();
      }
      this.$forceUpdate();
    },
    onErrorPwd() {
      this.loadingOff();
      this.isAuthLoading = false;
      this.isAuthLoadingError = true;
      this.passwd = "";
    },
    toEdit(data){
      let path = "/a/"
      let routeData = this.$router.resolve({path: path,query: {qr: data.dispatchDate + "-" + data.truck}});
      window.open(routeData.href, '_blank');
    },
    convertDateFormat(strDate) {
      strDate = strDate.replaceAll("/", "");
      strDate = strDate.replaceAll("-", "");
      strDate = strDate.replaceAll(":", "");
      strDate = strDate.replaceAll(" ", "");

      return (
        strDate.slice(0, 4) +
        "/" +
        strDate.slice(4, 6) +
        "/" +
        strDate.slice(6, 8)
      );
    },
  },
};
</script>
